namespace TabAurous.Inventory {
    export interface LotCreationForm {
        TransDate: Serenity.DateEditor;
        Posted: LabelEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        AutoPosting: Serenity.BooleanEditor;
        VoucherNo: Serenity.StringEditor;
        Details: LotCreationDetailsEditor;
        CommonItemDetails: LotCreationCommonEditor;
        UserId: Serenity.IntegerEditor;
        EmployeeId: Serenity.IntegerEditor;
        CompanyId: Serenity.IntegerEditor;
        FinancialYearId: Serenity.IntegerEditor;
    }

    export class LotCreationForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.LotCreation';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!LotCreationForm.init)  {
                LotCreationForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = LabelEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.BooleanEditor;
                var w4 = s.StringEditor;
                var w5 = LotCreationDetailsEditor;
                var w6 = LotCreationCommonEditor;

                Q.initFormType(LotCreationForm, [
                    'TransDate', w0,
                    'Posted', w1,
                    'VoucherTypeId', w2,
                    'AutoPosting', w3,
                    'VoucherNo', w4,
                    'Details', w5,
                    'CommonItemDetails', w6,
                    'UserId', w2,
                    'EmployeeId', w2,
                    'CompanyId', w2,
                    'FinancialYearId', w2
                ]);
            }
        }
    }
}
